import type { EditorPlugin } from '../../types/aha-editor';
import Markdown from '../Markdown/Markdown';
import BlockUtils from './BlockUtils';
import { type Editor } from 'slate';

const convertToBlockOfType =
  (type: string) =>
  (editor: Editor): void => {
    BlockUtils.toggleBlock(editor, type);
  };

const revertBlock = (editor: Editor): void => {
  BlockUtils.wrapBlocks(editor, 'paragraph');
};

interface BlockMarkdownPluginOptions {
  type: string;
  shortcuts: string[];
  triggerCharacters?: string[];
  dependencies?: EditorPlugin[];
}

const BlockMarkdownPluginFactory = ({
  type,
  shortcuts,
  triggerCharacters,
  dependencies = [],
}: BlockMarkdownPluginOptions): EditorPlugin => {
  return {
    name: `${type} Block markdown plugin`,
    dependencies: [Markdown, ...dependencies],
    markdown: [
      {
        type: 'block',
        shortcuts,
        convert: convertToBlockOfType(type),
        shiftTabRevert: true,
        ignoreUncaptured: false,
        ignoreSameCharacterString: false,
        revert: revertBlock,
        triggerCharacters,
      },
    ],
  };
};

export default BlockMarkdownPluginFactory;
